var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Modal',{attrs:{"class-name":"vertical-center-modal","footer-hide":""},model:{value:(_vm.showModal),callback:function ($$v) {_vm.showModal=$$v},expression:"showModal"}},[(_vm.showModal)?_c('LoginForm'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }